import { useScopes } from 'hooks/useScopes';
import { useCallback } from 'react';
import { EcomScope } from '../../pb/scopes/v1/ecom_scope_pb';

/**
 * Scope-based permission checks. `isLoading` matters for gating UI: while the scopes are still
 * being fetched `hasPermission` returns false, so render a skeleton/nothing rather than an
 * "access denied" state until the list has arrived.
 */
const usePermission = () => {
    const { data: scopes, isLoading, error } = useScopes();

    const hasPermission = useCallback((scope: EcomScope) => !!scopes?.includes(scope), [scopes]);

    const hasEveryPermission = useCallback(
        (requiredScopes: EcomScope[]) => requiredScopes.every((scope) => hasPermission(scope)),
        [hasPermission]
    );

    const hasSomePermission = useCallback(
        (requiredScopes: EcomScope[]) => requiredScopes.some((scope) => hasPermission(scope)),
        [hasPermission]
    );

    return { scopes, isLoading, error, hasPermission, hasEveryPermission, hasSomePermission };
};

export default usePermission;
